import * as Yup from 'yup';

export class CreateDocumentValidator {
  constructor() {}

  public get schema() {
    return Yup.object().shape({
      description: Yup.string().required('Informe a descrição'),
      category: Yup.string().required('Informe a categoria'),
      file: Yup.mixed<File>()
        .required('O arquivo é obrigatório')
        .test('fileSize', 'O arquivo deve ter no máximo 10MB', (value) => {
          if (!value) return false;
          return value.size <= 10 * 1024 * 1024; // 10MB
        }),
    });
  }
}
